<ng-container *ngIf="formContainer">
  <button
    type="submit"
    pButton
    [icon]="actionIcon | faSpin: formContainer.submitted"
    [label]="submitLabel | translate"
    class="primary-action"
    [ngClass]="submitClass"
    [disabled]="submitDisabled"
    (click)="onSubmit()"
  ></button>
  <button
    *ngIf="showCancel"
    type="button"
    pButton
    [icon]="cancelIcon"
    [label]="cancelLabel | translate"
    class="secondary-action p-button-secondary"
    [ngClass]="cancelClass"
    (click)="onCancel()"
    [disabled]="formContainer.submitted"
  ></button>
  <div class="other-actions">
    <ng-content></ng-content>
  </div>
</ng-container>
